import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export class FormHelper {
  public static getControlPath(control: AbstractControl, path: string[] = []): string[] {
    if (!control.parent) {
      return path;
    }

    const controlsKeys: string[] = Array.isArray(control.parent.controls)
      ? Array.from(Array(control.parent.controls.length).keys()).map((i) => i.toString())
      : Object.keys(control.parent.controls);

    for (const key of controlsKeys) {
      if (control.parent.get(key) === control) {
        return this.getControlPath(control.parent, [key, ...path]);
      }
    }

    return path;
  }

  public static updateValueAndValidity(control: AbstractControl): void {
    if (control instanceof FormGroup || control instanceof FormArray) {
      Object.keys(control.controls).forEach((key: string) => {
        this.updateValueAndValidity(control.controls[key]);
      });
    }

    control.updateValueAndValidity();
  }
}
